import { Ajax2 } from '@shared/Ajax';

export interface ExportJob {
    startedAt: number;
    jobUuid: string;
}

export interface ExportStatus {
    finishedAt: number | null;
    startedAt: number | null;
    jobUuid: string;
    resultObjectKey: string | null;
    stage: string;
    totalImages: number | null;
    annotatedImages: number | null;
}

function toExportJob(resp: any): ExportJob | null {
    const startedAt = resp?.started_at ?? resp?.startedAt;
    const jobUuid = resp?.job_uuid ?? resp?.jobUuid;
    if (startedAt && jobUuid) {
        return { startedAt, jobUuid };
    }
    return null;
}

function toExportStatus(resp: any): ExportStatus | null {
    if (!resp || !resp.stage) return null;
    return {
        finishedAt: resp.finished_at ?? resp.finishedAt ?? null,
        startedAt: resp.started_at ?? resp.startedAt ?? null,
        jobUuid: resp.job_uuid ?? resp.jobUuid,
        resultObjectKey: resp.result_object_key ?? resp.resultObjectKey ?? null,
        stage: resp.stage,
        totalImages: resp.total_images ?? resp.totalImages ?? null,
        annotatedImages: resp.annotated_images ?? resp.annotatedImages ?? null,
    };
}

async function startExport(selectedImages?: string[]): Promise<ExportJob | null> {
    if (selectedImages) {
        const resp = await Ajax2({
            url: kuura.AwsApiGatewayDomain() + '/metamarker/v1/export-selected?project_uuid=' + kuura.getProjectUuid(),
            method: 'POST',
            useToken: true,
            data: selectedImages,
            contentType: 'json',
        });

        const job = toExportJob(resp);
        if (job) {
            return job;
        }
    }

    const resp = await Ajax2({
        url: kuura.AwsApiGatewayDomain() + '/metamarker/v1/export?project_uuid=' + kuura.getProjectUuid(),
        method: 'GET',
        useToken: true,
    });

    return toExportJob(resp);
}

async function getStatusForExportJob(job: ExportJob): Promise<ExportStatus | null> {
    try {
        const resp = await Ajax2({
            url: kuura.AwsApiGatewayDomain() + '/metamarker/v1/export/status?project_uuid=' + kuura.getProjectUuid() + '&job_uuid=' + job.jobUuid,
            method: 'GET',
            useToken: true,
        });

        return toExportStatus(resp);
    } catch (error: unknown) {
        if (error instanceof Error) {
            console.error('Failed to get export status for job', error.message);
        }

        return null;
    }
}

async function getLatestStatusForProject(projectUuid: string): Promise<ExportStatus | null> {
    try {
        const resp = await Ajax2({
            url: kuura.AwsApiGatewayDomain() + '/metamarker/v1/export/status/latest?project_uuid=' + projectUuid,
            method: 'GET',
            useToken: true,
        });

        return toExportStatus(resp);
    } catch (error: unknown) {
        if (error instanceof Error) {
            console.error('Failed to get latest export status for project', error.message);
        }

        return null;
    }
}

export const PixelPackerService = {
    startExport,
    getStatusForExportJob,
    getLatestStatusForProject,
};
